// extracted by mini-css-extract-plugin
export default {"title":"toggle2_title__2X4y0","toggleContainer":"toggle2_toggleContainer__sr9YJ","toggle":"toggle2_toggle__mwBDE","text":"toggle2_text__DfXwu"};